import { ReactElement } from 'react';
import { Flex, Text, FlexProps } from '@chakra-ui/react';

type TextTagProps = FlexProps & {
  text: string;
  backgroundColor: string;
  textColor?: string;
  icon?: ReactElement;
  minH?: string;
};

export const TextTag = ({
  text,
  backgroundColor,
  textColor = 'primary.50',
  icon,
  minH,
  ...props
}: TextTagProps): ReactElement => {
  const heightProps = minH ? { minH } : { h: '20px' };

  return (
    <Flex
      alignItems='center'
      mr={2}
      bg={backgroundColor}
      p={1}
      borderRadius={4}
      textColor={textColor}
      fontSize='xs'
      data-testid='text-tag-container'
      {...heightProps}
      {...props}
    >
      {icon && <Flex mr={1}>{icon}</Flex>}
      <Text data-testid='text-tag-text'>{text}</Text>
    </Flex>
  );
};
